module.exports = __webpack_public_path__ + "static/media/plugin.1746cd3d.png";